export default __webpack_public_path__ + "static/media/tab-content-image-06.b5c581db.jpg";